import React from "react";
import Button from "../Components/Button";

const ResPage = ({ res, onNewOperationClick }) => {
  return (
    <div className="resPage">
      <div>{res.msg}</div>
      {res.maskedPan ? <div>شماره کارت:{res.maskedPan}</div> : null}
      <Button
        text="انجام عملیات جدید"
        variant="contained"
        onClick={onNewOperationClick}
      />
    </div>
  );
};

export default ResPage;
